module.exports = __webpack_public_path__ + "img/hr-branch-particle-shadow-09.716a9eb5.png";